<div class="container-fluid m-0 p-0">
    <div class="row">
        <div class="col-12 d-flex flex-wrap justify-content-between">
            <!-- <div class="col-12 d-flex flex-wrap justify-content-between" *ngIf="globals.checkUserHasPermission('COUNTRIES - CREATE')"> -->
            <!-- <button type="button" class="btn btn-success mb-2 mx-lg-0 mx-auto rounded-0"
                routerLink="/enrolment/create-course"><i class="fas fa-plus"></i> {{ "CREATE_COURSE" | translate |
                titlecase }}</button> -->
        </div>

        <div class="col-12">
            <div class="bg-white border pt-3 my-4">
                <h5 class="font-16 font-black px-3">{{ "ADD_STUDENT" | translate | titlecase }}</h5>
                <br>
                <form [formGroup]="findStudent" (change)="findStudentChange()" (submit)="findStudentSubmit()"
                    class="row">
                    <!-- <div class="col-md-12">
                        <div style="text-align: center;font-size: 16px;font-weight: bold;" class="alert-danger" *ngIf="showStudentSearchError">{{ "PLEASE_ENTER_VALID_DATA" | translate | titlecase }}</div>
                    </div> -->
                    <br/>
                    <div class="row" style="margin: auto;">
                        <div class="col-md-8 form-group px-md-5 mb-4">
                            <label class="text-bold">{{ "MAT_NO" | translate | titlecase }}</label>
                            <input type="text" class="form-control" formControlName="matNo">
                            <div class="alert alert-danger py-1 mt-1"
                            *ngIf="findStudent.controls.matNo.touched && findStudent.controls.matNo.invalid && findStudent.dirty">
                            {{ "PLEASE_ENTER_VALID_VALUE" | translate | titlecase }}
                        </div>
                        </div>
                        <!-- <div class="col-md-5 form-group px-md-5 mb-4">
                            <label class="text-bold">{{ "STUDENT_FULL_NAME" | translate | titlecase }}</label>
                            <input type="text" class="form-control" formControlName="studentFullName">
                        </div> -->
                        <div class="col-md-2 form-group px-md-5 mb-4"
                            style="padding-top: 23px;padding-left: 0px !important;">
                            <button type="submit" class="btn btn-primary">
                                {{ "SEARCH" | translate | titlecase }}</button>
                        </div>
                    </div>
                </form>
                <hr />
                <app-loader [show]="showLoader"></app-loader>

                <!-- <div style="text-align: center;font-size: 16px;font-weight: bold;" *ngIf="false">Show message here if enrollment is finilizes</div> -->
                <div class="col-12" *ngIf="showStudentInfo">
                    <form [formGroup]="addStudentForm" (change)="addStudentFormChange()"
                        (submit)="addStudentFormSubmit()">
                        <div class="row">
                            <div class="col-md-4 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "FULL_NAME_ENGLISH" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="fullNameEnglish"
                                    [attr.readonly]="!editable">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="addStudentForm.controls.fullNameEnglish.touched && addStudentForm.controls.fullNameEnglish.invalid && addStudentForm.dirty">
                                    {{ "PLEASE_ENTER_VALID_VALUE" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-4 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "FULL_NAME_ARABIC" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="fullNameAr"
                                    [attr.readonly]="!editable">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="addStudentForm.controls.fullNameAr.touched && addStudentForm.controls.fullNameAr.invalid && addStudentForm.dirty">
                                    {{ "PLEASE_ENTER_VALID_VALUE" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-4 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "STATE" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="studentState"
                                    [attr.disabled]="!editable">
                                    <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                        }}
                                    </option>
                                    <option *ngFor="let field of studentStates" [ngValue]="field.id">
                                        {{(globals.lang == 'ar')? field.sstatusNameAr : field.sstatusNameEn}}</option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="addStudentForm.controls.fullNameAr.touched && addStudentForm.controls.fullNameAr.invalid && addStudentForm.dirty">
                                    {{ "PLEASE_ENTER_VALID_VALUE" | translate | titlecase }}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "EMAIL" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="email"
                                    [attr.readonly]="!editable">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="addStudentForm.controls.email.touched && addStudentForm.controls.email.invalid && addStudentForm.dirty">
                                    {{ "PLEASE_ENTER_VALID_VALUE" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-4 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "FIRST_NAME_EN" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="firstNameEn"
                                    [attr.readonly]="!editable">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="addStudentForm.controls.firstNameEn.touched && addStudentForm.controls.firstNameEn.invalid && addStudentForm.dirty">
                                    {{ "PLEASE_ENTER_VALID_VALUE" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-4 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "LAST_NAME_EN" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="lastNameEn"
                                    [attr.readonly]="!editable">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="addStudentForm.controls.lastNameEn.touched && addStudentForm.controls.lastNameEn.invalid && addStudentForm.dirty">
                                    {{ "PLEASE_ENTER_VALID_VALUE" | translate | titlecase }}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "FIRST_NAME_AR" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="firstNameAr"
                                    [attr.readonly]="!editable">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="addStudentForm.controls.firstNameAr.touched && addStudentForm.controls.firstNameAr.invalid && addStudentForm.dirty">
                                    {{ "PLEASE_ENTER_VALID_VALUE" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-4 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "LAST_NAME_AR" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="lastNameAr"
                                    [attr.readonly]="!editable">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="addStudentForm.controls.lastNameAr.touched && addStudentForm.controls.lastNameAr.invalid && addStudentForm.dirty">
                                    {{ "PLEASE_ENTER_VALID_VALUE" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-4 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "NATIONAL_ID" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="nationalId"
                                    [attr.readonly]="!editable">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="addStudentForm.controls.nationalId.touched && addStudentForm.controls.nationalId.invalid && addStudentForm.dirty">
                                    {{ "PLEASE_ENTER_VALID_VALUE" | translate | titlecase }}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "ADDRESS" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="address"
                                    [attr.readonly]="!editable">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="addStudentForm.controls.address.touched && addStudentForm.controls.address.invalid && addStudentForm.dirty">
                                    {{ "PLEASE_ENTER_VALID_VALUE" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-4 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "PHONE_Number" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="phoneNumber"
                                    [attr.readonly]="!editable">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="addStudentForm.controls.phoneNumber.touched && addStudentForm.controls.phoneNumber.invalid && addStudentForm.dirty">
                                    {{ "PLEASE_ENTER_VALID_VALUE" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-4 form-group px-md-5 mb-4">
                                <label class="font-bold"> {{ "GENDER" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="gender"
                                    [attr.disabled]="!editable">
                                    <option [ngValue]="">{{ "SELECT" | translate | titlecase }}</option>
                                    <option value="M">{{ "MALE" | translate | titlecase }}</option>
                                    <option value="F">{{ "FEMALE" | translate | titlecase }}</option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="addStudentForm.controls.gender.touched && addStudentForm.controls.gender.invalid && addStudentForm.dirty">
                                    {{"PLEASE_SELECT_A_GENDER" | translate | titlecase}}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4 form-group px-md-5 mb-4">
                                <div id="imageContainer"
                                    style="background-color: #ecf0f3; text-align: center; margin: auto;">
                                    <img [src]="studentImageUrl" class="img-fluid " width="120" id="userImageTag">
                                </div>
                            </div>
                            <div class="col-md-4 form-group px-md-5 mb-4" style="padding-top: 20px;">
                                <label class="font-bold">{{ "SEMETER" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="semester"
                                [attr.readonly]="!editable">
                                <!-- <select class="form-control custom-select" formControlName="semester"
                                    [attr.disabled]="!editable">
                                    <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                        }}
                                    </option>
                                    <option *ngFor="let field of semesters" [ngValue]="field.key">
                                        {{field.value}}</option>
                                </select> -->
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="addStudentForm.controls.semester.touched && addStudentForm.controls.semester.invalid && addStudentForm.dirty">
                                    {{ "PLEASE_ENTER_VALID_VALUE" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-4 form-group px-md-5 mb-4" style="padding-top: 20px;">
                                <label class="font-bold">{{ "BATCH" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="batch"
                                    [attr.disabled]="!editable">
                                    <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                        }}
                                    </option>
                                    <option *ngFor="let element of batchs" [ngValue]="element.id">
                                        {{(globals.lang == 'ar')? element.gradeNameAr : element.gradeNameEn}}
                                    </option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="addStudentForm.controls.batch.touched && addStudentForm.controls.batch.invalid && addStudentForm.dirty">
                                    {{ "PLEASE_ENTER_VALID_VALUE" | translate | titlecase }}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4 form-group px-md-5 mb-4" style="margin: auto;">
                                <label class="font-bold">{{ "MAT_NO" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="matNo"
                                    [attr.readonly]="!editable">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="addStudentForm.controls.matNo.touched && addStudentForm.controls.matNo.invalid && addStudentForm.dirty">
                                    {{ "PLEASE_ENTER_VALID_VALUE" | translate | titlecase }}
                                </div>
                            </div>
                        </div>
                    </form>
                    <br>
                    <h5 class="font-16 font-black px-3">{{ "REPEATER" | translate | titlecase }}</h5>
                    <div style="text-align: center;font-size: 16px;font-weight: bold;" class="alert-danger" *ngIf="showRepeaterTableError">{{ "PLEASE_SELECT_ALL_DATA_BELOW" | translate | titlecase }}</div>
                    <app-loader [show]="loadingStudentRepeater"></app-loader>
                    <div class="table-responsive py-3" *ngIf="!loadingStudentRepeater">
                        <table class="table-striped" id="datatable">
                            <thead>
                                <tr>
                                    <th>{{ "SUBJECT_CODE" | translate | titlecase }}</th>
                                    <th>{{ "SUBJECT_NAME" | translate | titlecase }}</th>
                                    <th>{{ "ACADEMIC_YEAR" | translate | titlecase }}</th>
    
                                    <th>{{ "SEMESTER" | translate | titlecase }}</th>
                                    <th>{{ "BATCH" | translate | titlecase }}</th>
                                    <th>{{ "STATUS" | translate | titlecase }}</th>

                                    <th class="border-0 font-14 px-2 text-grey"></th>
                                    <!-- <th class="border-0 font-14 px-2 text-grey" *ngIf="globals.checkUserHasPermission('COUNTRIES - UPDATE')">{{ "COURSE_MODIFY" | translate | titlecase }}</th> -->
                                </tr>
                                <tr>
                                    <td>
                                        <div class="form-group">
                                            <select #subjectsDropdown (input)="repeaterSubjectId = subjectsDropdown.value" (change)="getSubjectName(subjectsDropdown.value)" class="form-control custom-select">
                                                <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                                    }}
                                                </option>
                                                <option *ngFor="let element of courses" value="{{element.id}}">
                                                    {{element.subjectCode}}
                                                    <!-- {{(globals.lang == 'ar')? element.subjectNameAr : element.subjectNameEn}} -->
                                                </option>
                                            </select>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-group">
                                            <input type="text" class="form-control" [(ngModel)]="repeaterSubjectName" placeholder="{{ 'SUBJECT_NAME' | translate | titlecase }}" readonly>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-group">
                                            <input type="text" class="form-control" value="{{(globals.lang == 'ar')? yearDes?.yearDescAr : yearDes?.yearDescEn}}" readonly>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-group">
                                            <input type="text" class="form-control" value="{{(globals.lang == 'ar')? semesterDes.semesterNameAr : semesterDes.semesterNameEn}}" readonly>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-group">
                                            <input type="text" class="form-control" [(ngModel)]="repeaterBatchName" placeholder="{{ 'BATCH_NAME' | translate | titlecase }}" readonly>
                                        </div>
                                    </td>
                                    <td>
                                        <div class="form-group">
                                            <select #repeaterStatusInput (input)="repeaterStatusId = repeaterStatusInput.value" class="form-control custom-select">
                                                <option value="" [selected]="true">{{ "SELECT" | translate | titlecase
                                                    }}
                                                </option>
                                                <option *ngFor="let field of subjectStates" value="{{field.id}}">
                                                    {{(globals.lang == 'ar')? field.ssstatusNameAr : field.ssstatusNameEn}}</option>
                                            </select>
                                        </div>
                                    </td>

                                    <td class="text-bold text-success">
                                        <a class="btn btn-sm btn-link text-success" (click)="addRepeater()">
                                            <i class="fas fa-plus"></i>
                                            {{ "ADD" | translate | titlecase }}</a>
                                    </td>
                                </tr>
                            </thead>
                            <tbody>

                                <tr *ngFor="let res of repeaters let i = index">
                                    <td>{{res?.subjectCode}}</td>
                                    <td>{{(globals.lang == 'ar')? res?.subjectNameAr : res?.subjectNameEn}}</td>
                                    <td>{{(globals.lang == 'ar')? yearDes?.yearDescAr : yearDes?.yearDescEn}}</td>
                                    <td>{{(globals.lang == 'ar')? semesterDes.semesterNameAr : semesterDes.semesterNameEn}}</td>
                                    <td>{{(globals.lang == 'ar')? res?.gradeNameAr : res?.gradeNameEn}}</td>
                                    <td>{{(globals.lang == 'ar')? res?.subjectStatusAr : res?.subjectStatusEn}}</td>
    
                                    <td class="text-bold text-warning">
                                        <a class="btn btn-sm btn-link text-warning" (click)="updateCurrentRepeaterId(res?.id)" data-toggle="modal"
                                        data-target="#deleteRepeaterModal">
                                            <i class="fas fa-trash"></i>
                                            {{ "REMOVE" | translate | titlecase }}</a>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <!-- <div class="row">
                        <div class="col-md-4 form-group px-md-5 mb-4" style="margin: auto;text-align: center;">
                            <button type="button" class="btn btn-success mb-2 mx-lg-0 mx-auto rounded-0" (click)="addStudentRepeaters()"> {{ "SUBMIT" | translate |
                                titlecase }}
                            </button>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="deleteRepeaterModal" tabindex="-1" aria-labelledby="deleteRepeaterModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">

            <div class="modal-body font-16 text-center d-flex justify-content-between">
                <div class="p-2">
                    <!-- <i class="fas fa-trash text-danger"></i> -->
                    <i class="fas fa-exclamation-triangle"></i>
                </div>
                <div class="p-2"><b>{{ "ARE_YOU_SURE" | translate | titlecase }}</b> </div>

                <a type="button" class="btn btn-link text-danger" (click)="removeRepeater()"
                    data-dismiss="modal">{{ "YES"
                    | translate | titlecase }}</a>
                <a type="button" class="btn btn-link text-grey" data-dismiss="modal"><i
                        class="fas fa-times-circle"></i></a>
            </div>
        </div>
    </div>
</div>